import { ArrowLeftIcon, ArrowRightIcon } from '../../assets';
import { CSS_SELECTOR, useCustomCss } from '../../contexts/CustomCss';
import { DenyLink, DenyLinkWrapper, LeftIcon, RightIcon, Wrapper } from './CNILHeader.styles';
import { FunctionalComponent, h } from 'preact';
import { memo } from 'preact/compat';

export interface CNILHeaderComponentProps {
  denyLinkText: string;
  onDenyAllHandler: () => void;
}

const CNILHeaderComponent: FunctionalComponent<CNILHeaderComponentProps> = memo(
  ({ denyLinkText, onDenyAllHandler }) => {
    const { rules } = useCustomCss(CSS_SELECTOR.LINKS);

    return (
      <Wrapper>
        <DenyLinkWrapper
          aria-labelledby="uc-cnil-deny-all"
          role="button"
          style={{ ...rules }}
          onClick={onDenyAllHandler}
          data-testid="uc-cnil-deny-all"
        >
          <LeftIcon>
            <ArrowLeftIcon />
          </LeftIcon>
          <DenyLink id="uc-cnil-deny-all"> {denyLinkText} </DenyLink>
          <RightIcon>
            <ArrowRightIcon />
          </RightIcon>
        </DenyLinkWrapper>
      </Wrapper>
    );
  },
);

export default CNILHeaderComponent;
